"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var iconDefaults = {
  path: 'assets/icons/',
  width: 10,
  extension: 'svg'
};

var Icon = function Icon(props) {
  return /*#__PURE__*/_react.default.createElement("img", _extends({
    "data-testid": "Icon",
    src: "".concat(props.path || iconDefaults.path).concat(props.name, ".").concat(props.extension || iconDefaults.extension),
    width: iconDefaults.width,
    alt: props.alt || "icon-".concat(props.name)
  }, props));
};

exports.Icon = Icon;